import axios from 'axios'
import {
    PRODUCT_LIST_REQUEST,
    PRODUCT_LIST_SUCCESS,
    PRODUCT_LIST_FAIL,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    BOOKMARKED_PRODUCT_LIST_REQUEST,
    BOOKMARKED_PRODUCT_LIST_REQUEST_SUCCESS,
    BOOKMARKED_PRODUCT_LIST_REQUEST_FAILED,
    PRODUCT_DEATIL_ADMIN_REQUEST,
    PRODUCT_DEATIL_ADMIN_SUCCESS,
    PRODUCT_DEATIL_ADMIN_FAIL,
    PRODUCT_DEATIL_ADMIN_RESET
} from './productConstants'

import * as TokenBaseFunc from "../../globalFuncs/TokenBaseActions";

export const detailproduct = (lang, pid) => async (
    dispatch
) => {
    try {
        dispatch({ type: PRODUCT_DETAILS_REQUEST })
        let res = []
        // if (TokenBaseFunc.TokenStatus()) {
        //     const config = {
        //         headers: {
        //             Authorization: `Bearer ` + userTokenLocal,
        //         },
        //     };
        //     res = await axios.get('/api/products/details?lan=' + lang + '&ProductId=' + pid, config)
        // }
        // else
        res = await axios.get('/api/products/details?lan=' + lang + '&ProductId=' + pid)
        if (res.data.status === "ok") {

            dispatch({
                type: PRODUCT_DETAILS_SUCCESS,
                payload: res.data.data
            })

        }
        else {
            dispatch({
                type: PRODUCT_DETAILS_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        dispatch({
            type: PRODUCT_DETAILS_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

export const listProducts = (lang, pageNumber = 1, keyword = '', mainCategoryId = 0, subCategoryId = 0, secondarySubCategoryId = 0, PriceMin = '', PriceMax = '', DescendingSort = false) => async (
    dispatch
) => {
    try {
        // = 1,  = null,  = null,  = null,  = null,  = null, PriceMax = null, descending = false
        dispatch({ type: PRODUCT_LIST_REQUEST })
        let adr = '/api/products?lan=' + lang
        if (pageNumber > 0)
            adr += '&page=' + pageNumber

        if (keyword !== '') {
            adr += '&keyword=' + keyword
        }
        if (mainCategoryId !== 0) {
            adr += '&mainCategoryId=' + mainCategoryId
        }
        if (subCategoryId > 0) {
            adr += '&subCategoryId=' + subCategoryId
        }
        if (secondarySubCategoryId !== 0) {
            adr += '&secondarySubCategoryId=' + secondarySubCategoryId
        }
        if (Number(PriceMin) !== 0) {
            adr += '&PriceMin=' + PriceMin
        }
        if (Number(PriceMax) !== 0) {
            adr += '&PriceMax=' + PriceMax
        }
        if (Boolean(DescendingSort))
            adr += '&DescendingSort=' + DescendingSort

        let res = []
        // if (TokenBaseFunc.TokenStatus()) {
        //     const config = {
        //         headers: {
        //             Authorization: `Bearer ` + userTokenLocal,
        //         },
        //     };
        //     res = await axios.get(adr, config)
        // }
        // else
        res = await axios.get(adr)

        if (res.data.status === "ok") {
            dispatch({
                type: PRODUCT_LIST_SUCCESS,
                payload: res.data.data
            })
        }
        else {
            dispatch({
                type: PRODUCT_LIST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: PRODUCT_LIST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }

}

export const listOfBookmarkedProducts = (pageNumber = 1) => async (
    dispatch
) => {

    try {

        dispatch({
            type: BOOKMARKED_PRODUCT_LIST_REQUEST,
        })

        if (TokenBaseFunc.TokenStatus()) {
            const config = {
                headers: {
                    Authorization: `Bearer ` + TokenBaseFunc.ReturnToken(),
                },
            };
            const { data } = await axios.get('/api/products/bookmarks/?page=' + pageNumber, config)
            if (data.status === "ok") {

                dispatch({
                    type: BOOKMARKED_PRODUCT_LIST_REQUEST_SUCCESS,
                    payload: data.data
                })

            }
            else {

                dispatch({
                    type: BOOKMARKED_PRODUCT_LIST_REQUEST_FAILED,
                    payload: 'خطا در دریافت اطلاعات از سرور'
                })
            }
        }
        else {

            dispatch({
                type: BOOKMARKED_PRODUCT_LIST_REQUEST_FAILED,
                payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
            })

        }

    } catch (error) {
        dispatch({
            type: BOOKMARKED_PRODUCT_LIST_REQUEST_FAILED,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }

}

export const getDetailProduct = (id) => async (
    dispatch
) => {
    const config = {
        headers: {
            Authorization: `Bearer ` + localStorage.getItem("token"),
            "Content-Type": "application/json",
        },
    };
    try {
        dispatch({ type: PRODUCT_DEATIL_ADMIN_REQUEST })
        const { data } = await axios.get('/api/admin/products/details?ProductId=' + id, config)
        if (data.status === "ok") {
            dispatch({
                type: PRODUCT_DEATIL_ADMIN_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: PRODUCT_DEATIL_ADMIN_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: PRODUCT_DEATIL_ADMIN_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}

// export const deleteProduct = (id) => async (dispatch, getState) => {
//     try {
//         dispatch({
//             type: PRODUCT_DELETE_REQUEST,
//         });

//         const {
//             userLogin: { userInfo },
//         } = getState();

//         const config = {
//             headers: {
//                 "content-type": "multipart/form-data",
//                 // Authorization: `Bearer ${userInfo.token}`,
//             },
//         };

//         const { data } = await axios.post(`/api/products/`, id, config);

//         dispatch({
//             type: PRODUCT_DELETE_SUCCESS,
//             payload: data
//         });
//     } catch (error) {
//         const message =
//             error.response && error.response.data.message
//                 ? error.response.data.message
//                 : error.message;
//         if (message === "Not authorized, token failed") {
//             dispatch(logout());
//         }
//         dispatch({
//             type: PRODUCT_DELETE_FAIL,
//             payload: message,
//         });
//     }
// };

// export const createProduct = (formData) => async (
//     dispatch,
//     getState
// ) => {
//     try {

//         dispatch({
//             type: PRODUCT_CREATE_REQUEST,
//         });

//         if (!TokenBaseFunc.TokenStatus) {
//             dispatch({
//                 type: PRODUCT_CREATE_FAIL,
//                 payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
//             })
//         }
//         else if (!TokenBaseFunc.CheckIsAdmin) {
//             dispatch({
//                 type: PRODUCT_CREATE_FAIL,
//                 payload: { status: false, message: 'دسترسی غیر مجاز!' }
//             })
//         }
//         else {

//             const config = {
//                 headers: {
//                     "content-type": "multipart/form-data",
//                     "Authorization": `Bearer ${TokenBaseFunc.ReturnToken}`,
//                 },
//             };

//             await axios.post(
//                 `/api/products/add1`,
//                 formData,
//                 config
//             ).then((response) => {

//                 if (response.data.status === "ok") {

//                     dispatch({
//                         type: PRODUCT_CREATE_SUCCESS,
//                         payload: { status: true, message: '' }
//                     })

//                 } else {

//                     dispatch({
//                         type: PRODUCT_CREATE_FAIL,
//                         payload: { status: false, message: '' }
//                     })

//                 }

//             })
//         }
//     } catch (error) {
//         const message =
//             error.response && error.response.data.message
//                 ? error.response.data.message
//                 : error.message;
//         if (message === "Not authorized, token failed") {
//             dispatch(logout());
//         }
//         dispatch({
//             type: PRODUCT_CREATE_FAIL,
//             payload: { status: true, message: message },
//         });
//     }
// };

// export const updateProduct = (productData) => async (
//     dispatch,
//     getState
// ) => {
//     try {
//         dispatch({
//             type: PRODUCT_UPDATE_REQUEST,
//         });

//         const {
//             userLogin: { userInfo },
//         } = getState();

//         const config = {
//             headers: {
//                 "content-type": "multipart/form-data",
//                 // Authorization: `Bearer ${userInfo.token}`,
//             },
//         };

//         const { data } = await axios.put(
//             `/api/products/update`,
//             productData,
//             config
//         );

//         dispatch({
//             type: PRODUCT_UPDATE_SUCCESS,
//             payload: data,
//         });
//     } catch (error) {
//         const message =
//             error.response && error.response.data.message
//                 ? error.response.data.message
//                 : error.message;
//         if (message === "Not authorized, token failed") {
//             dispatch(logout());
//         }
//         dispatch({
//             type: PRODUCT_UPDATE_FAIL,
//             payload: message,
//         });
//     }
// };


